import { useLang } from "../i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <section data-testid="marquee" className="relative border-y border-white/10 bg-black overflow-hidden">
      <div className="marquee-track py-6">
        {items.map((w, i) => (
          <div key={i} className="flex items-center shrink-0 pr-12">
            <span className="font-display text-3xl md:text-5xl uppercase tracking-tighter text-white/85">
              {w}
            </span>
            <span
              className="ml-12 inline-block w-2 h-2 rotate-45"
              style={{ background: i % 2 === 0 ? "hsl(var(--coral))" : "hsl(var(--mustard))" }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
